import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Wine, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { IMAGES } from "../lib/images";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain relative min-h-screen bg-wine-bg grid grid-cols-1 md:grid-cols-2">
      <div className="relative hidden md:block">
        <img src={IMAGES.barrels} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-wine-bg/60" />
        <div className="absolute bottom-12 left-12 z-10">
          <span className="font-display text-4xl text-cream leading-tight">
            Macarthur <span className="italic text-terracotta">Wine</span> Society
          </span>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-smoke hover:text-gold transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back to site
          </Link>
          <div className="mt-8 flex items-center gap-3">
            <Wine className="h-6 w-6 text-gold" />
            <h1 className="font-display text-3xl text-cream">Admin sign in</h1>
          </div>
          <p className="mt-2 text-smoke">Manage members, gatherings and ideas.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label className="text-smoke">Email</Label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 bg-wine-surface border-white/15 text-cream" />
            </div>
            <div>
              <Label className="text-smoke">Password</Label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 bg-wine-surface border-white/15 text-cream" />
            </div>
            <button
              data-testid="login-submit"
              disabled={busy}
              className="w-full rounded-full bg-gold py-3.5 text-sm font-semibold uppercase tracking-[0.14em] text-wine-bg transition-all duration-300 hover:bg-cream disabled:opacity-60"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
